import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import ItemDatatables from "component/master/item/ItemDatatables";
import ItemModalForm from "component/master/item/ItemModalForm";
import ItemFeature from "component/master/item/ItemFeature";
import ImagePreview from "component/master/item/ImagePreview";
import ItemPrice from "component/master/item/ItemPrice";

function Item() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeContent, setActiveContent] = useState("item");
  const [category, setCategory] = useState([]);
  const [item, setItem] = useState([]);
  const [feature, setFeature] = useState([]);
  const [featureItem, setFeatureItem] = useState([]);
  const [priceItem, setPriceItem] = useState([]);

  const fetchItem = async () => {
    const token = localStorage.getItem("token");
    try {
      const responseItem= await fetch(`${process.env.REACT_APP_API}/item`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      if (!responseItem.ok) throw new Error("Gagal mengambil data Item");
      const dataItem = await responseItem.json();
      setItem(dataItem.data);

      const responseCategory = await fetch(`${process.env.REACT_APP_API}/category`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      if (!responseCategory.ok) throw new Error("Gagal mengambil data category");
      const dataCategory = await responseCategory.json();
      setCategory(dataCategory.data);
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };
  
  const fetchFeatureItem = async (item_id) => {
    const token = localStorage.getItem("token");
    try {
      const responseFeatureItem= await fetch(`${process.env.REACT_APP_API}/feature-item`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ item_id })
      });
      if (!responseFeatureItem.ok) throw new Error("Gagal mengambil data Feature Item");
      const dataFeatureItem = await responseFeatureItem.json();
      setFeatureItem(dataFeatureItem.data);

      const responseFeature = await fetch(`${process.env.REACT_APP_API}/feature`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!responseFeature.ok) throw new Error("Gagal mengambil data feature");
  
      const dataFeature = await responseFeature.json();
      setFeature(dataFeature.data);
    } catch (error) {
      console.error("Error fetching feature:", error);
    }
  };

  const fetchItemPrice = async (item_id) => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_API}/item-price`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ item_id }),
        }
      );

      if (!response.ok) {
        throw new Error("Gagal mengambil data price item");
      }

      const data = await response.json();
      setPriceItem(data.data); // 👈 simpan ke state parent
    } catch (error) {
      console.error("Error fetching item price:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Item";
      window.scrollTo(0, 0);
      fetchItem();
  }, []);

  const handleAddItem = () => {
    setModalMode("add");
    setSelectedItem(null);
    setIsModalOpen(true);
  }

  const handleShowImage = (item) => {
    setSelectedItem(item);
    setActiveContent("image");
  }

  const handleEditItem = (item) => {
    setModalMode("edit");
    setSelectedItem(item);
    setIsModalOpen(true);
  }

  const handleDeleteItem = async (item) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Item',
        text: `Apakah Anda yakin ingin menghapus Item ${item.title}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      if (!item?.item_id) {
        alert("Item ID tidak ditemukan");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API}/item/${item.item_id}`
      );

  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Item berhasil dihapus");
        fetchItem();
      } else {
        showError(response.data.message || "Gagal menghapus Item");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Item");
    }
  };

  const handleAddFeature = (item) => {
    setSelectedItem(item);
    fetchFeatureItem(item.item_id);
    setActiveContent("feature");
  }

  const handleAddPrice = async (item) => {
    setSelectedItem(item);
    fetchItemPrice(item.item_id);
    setActiveContent("price");
  };

  const handleBackToItem = () => {
    fetchItem();
    setActiveContent("item");
  };

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <>
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "item" && (
                            <div className="row content-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title m-0">Item Management</h5>
                                <i
                                  className="bx bxs-plus-square"
                                  style={{ color: "blue", fontSize: 50, cursor: "pointer" }}
                                  onClick={handleAddItem}
                                ></i>
                              </div>
                              <ItemDatatables
                                data={item}
                                onShowImage={handleShowImage}
                                onEditItem={handleEditItem}
                                onDeleteItem={handleDeleteItem}
                                onAddFeature={handleAddFeature}
                                onAddPrice={handleAddPrice}
                              />
                            </div>
                          )}

                          {activeContent === "image" && (
                            <div className="row content-image">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title m-0">Show Image</h5>
                              </div>
                              <ImagePreview item={selectedItem} onBackToItem={handleBackToItem} />
                            </div>
                          )}

                          {activeContent === "feature" && (
                            <div className="row content-feature-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title m-0">Feature Item {selectedItem.title}</h5>
                              </div>
                              <ItemFeature
                                itemData={featureItem}
                                feature={feature}
                                itemId={selectedItem.item_id}
                                onBackToItem={handleBackToItem}
                                onSuccess={(item_id) => fetchFeatureItem(item_id)}
                              />
                            </div>
                          )}

                          {activeContent === "price" && selectedItem && (
                            <div className="row content-price-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title m-0">
                                  Price Item {selectedItem.title}
                                </h5>
                              </div>

                              <ItemPrice
                                itemData={priceItem}
                                itemId={selectedItem.item_id}
                                onBackToItem={handleBackToItem}
                                onSuccess={(item_id) => fetchItemPrice(item_id)}
                              />
                            </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <ItemModalForm mode={modalMode} itemData={selectedItem} categoryData={category} closeModal={closeModal} onSuccess={fetchItem}/>
        </div>
      )}

    </div>
    </>
  );
}

export default Item;
